import type { IconOrEmoji } from '@n8n/design-system';

export const PROJECT_MOVE_RESOURCE_MODAL = 'projectMoveResourceModal';

export const DEFAULT_PROJECT_ICON: IconOrEmoji = { type: 'icon', value: 'layers' };
